import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    submissionNodeData: []
}

const submissionTreeSlice = createSlice({
  name: 'submissionTree',
  initialState,
  reducers: {
    setsubmissionNodeData: (state, action) => {
      state.submissionNodeData = action.payload
    }
  }
})

export const { setsubmissionNodeData } = submissionTreeSlice.actions

export default submissionTreeSlice.reducer